import React, { useEffect, useState } from 'react';
import { getAuthToken } from '../../auth/context/AuthContext';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/platform`;

export default function PlatformSettings() {
  const [markup, setMarkup] = useState('');
  const [err, setErr] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let gone = false;
    (async () => {
      try {
        const res = await fetch(`${API}/settings`, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not load settings');
        if (!gone) setMarkup(String(data.ai_markup ?? 10));
      } catch (e) {
        if (!gone) setErr(e.message);
      } finally {
        if (!gone) setLoading(false);
      }
    })();
    return () => { gone = true; };
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setErr('');
    setNote('');
    setBusy(true);
    try {
      const res = await fetch(`${API}/settings`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ai_markup: Number(markup) }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not save the markup');
      setMarkup(String(data.ai_markup));
      setNote(`AI markup is now ${data.ai_markup}×. Companies without their own markup use this.`);
    } catch (error) {
      setErr(error.message);
    }
    setBusy(false);
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Settings</div>
          <div className="page-subtitle">Platform settings for every company</div>
        </div>
      </div>
      {loading && !err && <div className="empty-state-text">Loading…</div>}
      {!loading && (
        <div className="card" style={{ maxWidth: 480, padding: 16 }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>AI markup</div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 14, lineHeight: 1.5 }}>
            Companies are charged this many times the measured AI cost. 10 means 10×.
            A company with its own markup uses that instead. Charges already on a wallet stay as they are.
          </div>
          {err && <div className="alert alert-error" style={{ marginBottom: 12 }}>{err}</div>}
          {note && <div style={{ fontSize: 13, marginBottom: 12 }}>{note}</div>}
          <form onSubmit={save}>
            <label className="form-group">
              <div className="form-label">Multiplier</div>
              <input
                className="form-input"
                type="number"
                min="1"
                max="100"
                step="1"
                required
                value={markup}
                onChange={(e) => setMarkup(e.target.value)}
                style={{ maxWidth: 160 }}
              />
            </label>
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? 'Saving…' : 'Save'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
